module.exports = __webpack_public_path__ + "static/photo3-bab0bd629b93ac8a4fdec862bc68074b.jpg";